<odx-modal-header>
  <odx-area-header i18n="@@group.modal.createNewGroup.header">Neue Gruppe erstellen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <form odxForm [formGroup]="groupNameForm">
    <odx-form-field i18n-label="@@group.modal.form.label" label="Gruppenname">
      <input
        formControlName="name"
        odxFormFieldControl
        i18n-placeholder="@@group.modal.form.placeholder"
        placeholder="Gruppenname"
      />
      <ng-template odxFormFieldError="required">
        <ng-container i18n="@@group.modal.form.groupNameRequired">Gruppennamen angeben </ng-container>
      </ng-template>
      <ng-template odxFormFieldError="maxlength">
        <ng-container i18n="@@group.modal.form.groupNameTooLong">
          Gruppenname darf nicht länger als 50 Zeichen sein
        </ng-container>
      </ng-template>
    </odx-form-field>
  </form>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss i18n="@@global.dismiss">Abbrechen</button>
  <button odxButton variant="primary" i18n="@@group.modal.button.confirm" (click)="onConfirm()">Bestätigen</button>
</odx-modal-footer>
